import { combineReducers } from "@reduxjs/toolkit";
import ludoReducer from "./ludoSlice";
import { userReducer as user } from "./reducers/user";

const tobePersisted = {
  // matches,
  user,
};
export const reducers = combineReducers({
  ...tobePersisted,
  ludo: ludoReducer,
});
export const tobePersistedKeys = Object.keys(tobePersisted);
